import React from "react";
import { Helmet } from "react-helmet";
import "./AboutUs.css";
import Image from "../Assets/mother.jpg";

const AboutUs = () => {
  return (
    <div className="about">
      <Helmet>
        <link rel="canonical" href="https://jaipurmasale.com/about-us" />
      </Helmet>
      <h2 className="about-title">A Legacy of Love and Design</h2>
      <hr/>
      <div className="about-container">
        <div className="about-content">
          <p className="about-text">
            Founded in June 2018 in Jaipur, Rajasthan, Kraafty began as a passion project to showcase Indian craftsmanship. Today, we are a globally recognized brand, offering ethically produced, handcrafted home décor, textiles, and garments while supporting artisans with fair wages and ethical work conditions.

          </p>
          <br />
          <p className="about-text">
              <strong>Our Mission:</strong>
          </p>
          <br />
          <p className="about-text">
            <strong>Empowering Artisans</strong> - Ensuring fair wages and preserving traditional skills.
          </p>
          <br />
          <p className="about-text">
            <strong>Sustainable Craftsmanship</strong> - Using natural materials like cotton, jute, and wood..
          </p>
          <br />
          <p className="about-text">
            <strong>Authentic & High-Quality</strong> - Every piece tells a story of heritage and artistry.
          </p>
          <br />
          <p className="about-signature">
            Sincerely,
            <br />
            {/* <strong>Garv Tambi</strong>
            <br /> */}
            Kraafty
          </p>
        </div>
        <div className="about-image">
          <img
            src={Image}
            alt="About Kraafty"
            width="600"  // Add explicit width
            height="400" // Add explicit height
            loading="lazy" // Lazy load the image
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
